import { defineComponent as s, useAttrs as c, computed as n, openBlock as a, createElementBlock as p, normalizeProps as u, guardReactiveProps as i } from "vue";
import { transformProps as _, transformSourceProps as d } from "@unpic/core";
const h = /* @__PURE__ */ s({
  __name: "image",
  props: {
    src: {},
    width: {},
    height: {},
    layout: {},
    cdn: {},
    priority: { type: Boolean },
    background: {},
    aspectRatio: {},
    objectFit: {},
    unstyled: { type: Boolean },
    transformer: { type: Function }
  },
  setup(t) {
    const o = t, e = c(), r = n(() => _({ ...e, ...o }));
    return (m, l) => (a(), p("img", u(i(r.value)), null, 16));
  }
}), y = /* @__PURE__ */ s({
  __name: "source",
  props: {
    src: {},
    width: {},
    height: {},
    layout: {},
    cdn: {},
    aspectRatio: {}
  },
  setup(t) {
    const o = t, e = c(), r = n(() => d({ ...e, ...o }));
    return (m, l) => (a(), p("source", u(i(r.value)), null, 16));
  }
});
export {
  h as Image,
  y as Source
};
